import React from 'react';

// initial context state
const AttachChecklistContext = React.createContext<any>({});

export default AttachChecklistContext;
